import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HandHoldingHand = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 576 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9l126.6-93.3C166.2 41.3 194.5 32 223.5 32H544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-36.8l-44.9 36c-22.7 18.2-50.9 28-80 28H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160h.9-.9zm185.8 144.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352h-.9.9z"
  }));
});
HandHoldingHand.displayName = 'HandHoldingHand';
export var HandHoldingHandDimensions = {
  height: 512,
  width: 576
};